"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.parseDigraphs = void 0;
const maven_graph_builder_1 = require("./maven-graph-builder");
const newLine = /[\r\n]+/g;
function parseDigraphs(digraphs) {
    const graphs = [];
    for (const digraph of digraphs) {
        const lines = digraph.split(newLine);
        const rootId = findQuotedContents(lines[0]);
        if (!rootId) {
            throw new Error(`Unexpected digraph could not find root node. Could not parse "${lines[0]}".`);
        }
        const builder = new maven_graph_builder_1.MavenGraphBuilder(rootId);
        for (let i = 1; i < lines.length - 1; i++) {
            const line = parseLine(lines[i]);
            if (!line) {
                throw new Error(`Unexpected digraph could not connect nodes. Could not parse "${lines[i]}".`);
            }
            builder.connect(line.from, line.to);
        }
        graphs.push(builder.graph);
    }
    return graphs;
}
exports.parseDigraphs = parseDigraphs;
function parseLine(line) {
    if (!line)
        return null;
    const [left, right] = line.split('->');
    if (!left || !right)
        return null;
    const from = findQuotedContents(left);
    const to = findQuotedContents(right);
    if (!from || !to)
        return null;
    return { from, to };
}
function findQuotedContents(value) {
    if (!value)
        return null;
    const start = value.indexOf('"') + 1;
    const end = value.lastIndexOf('"');
    return value.substring(start, end);
}
//# sourceMappingURL=digraph.js.map